// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__fqLO-","slider":"switch_slider__3O1fH","round":"switch_round__k+2M5"};